function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M1.25 10.5C1.25 12.8206 2.17187 15.0462 3.81282 16.6872C5.45376 18.3281 7.67936 19.25 10 19.25C12.3206 19.25 14.5462 18.3281 16.1872 16.6872C17.8281 15.0462 18.75 12.8206 18.75 10.5C18.75 8.17936 17.8281 5.95376 16.1872 4.31282C14.5462 2.67187 12.3206 1.75 10 1.75C7.67936 1.75 5.45376 2.67187 3.81282 4.31282C2.17187 5.95376 1.25 8.17936 1.25 10.5Z",
    stroke: "#1A4338",
    style: {
      stroke: "#1A4338",
      stroke: "color(display-p3 0.1020 0.2627 0.2196)",
      strokeOpacity: 1
    },
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.25 10.5C6.25 8.17936 6.64509 5.95376 7.34835 4.31282C8.05161 2.67187 9.00544 1.75 10 1.75C10.9946 1.75 11.9484 2.67187 12.6516 4.31282C13.3549 5.95376 13.75 8.17936 13.75 10.5C13.75 12.8206 13.3549 15.0462 12.6516 16.6872C11.9484 18.3281 10.9946 19.25 10 19.25C9.00544 19.25 8.05161 18.3281 7.34835 16.6872C6.64509 15.0462 6.25 12.8206 6.25 10.5Z",
    stroke: "#1A4338",
    style: {
      stroke: "#1A4338",
      stroke: "color(display-p3 0.1020 0.2627 0.2196)",
      strokeOpacity: 1
    },
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.875 13.4167H18.125M1.875 7.58337H18.125",
    stroke: "#1A4338",
    style: {
      stroke: "#1A4338",
      stroke: "color(display-p3 0.1020 0.2627 0.2196)",
      strokeOpacity: 1
    },
    strokeWidth: 1.25,
    strokeLinecap: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.927187ef099496b452dafd289328a474.svg";
export { ForwardRef as ReactComponent };